
<template>
  <!-- Main content -->
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header  v-bind:fromdate="fromDate" v-bind:todate="toDate"/> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-3">
              <h2>Dashboard</h2>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                  <li class="breadcrumb-item">
                    <i class="fas fa-home"></i>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                </ol>
              </nav>
            </div>
            <div class="col-lg-9 d-flex align-content-start flex-wrap tradeDate">
              <!-- <h4>Trade Date Range</h4> -->
              <form>
                <div class="form-group">
                  <label for="exampleFormControlInput1">Trade Date From</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="fromDate"
                    placeholder="MM/DD/YYYY"
                    @change="setDate"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleFormControlInput1">Trade Date To</label>
                  <input type="date" class="form-control" @change="setDate" v-model="toDate" placeholder="MM/DD/YYYY" />
                </div>
              </form>
              <!-- <Tradecount v-bind:fromdate="fromDate" v-bind:todate="toDate" /> -->
            </div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6 dashboard">
      <div class="row">
        <div class="col-xl-4 col-md-4">
          <MaturityGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" />
        </div>
        <div class="col-xl-4 col-md-4">
          <InsuredGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" />
        </div>
        <div class="col-xl-4 col-md-4">
          <MoodysRatingGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" />
        </div>
      </div>
      <div class="row">
        <div class="col-xl-8 col-md-8">
          <!-- <StatereportGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" /> -->
          <StateReportGraphwithGchart v-bind:fromdate="fromDate" v-bind:todate="toDate" />
        </div>
        <div class="col-xl-4 col-md-4">
          <div class="row">
            <div class="col-xl-12 col-md-12">
              <SPRatingGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" />
            </div>
            <div class="col-xl-12 col-md-12">
              <InsuranceGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-xl-8 col-md-8"> -->
          <!-- <PurposeGraphwithGchart v-bind:fromdate="fromDate" v-bind:todate="toDate" /> -->
          <!-- <PurposeGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" /> -->
        <!-- </div> -->
        <div class="col-xl-12 col-md-12">
          <div class="row">
            <div class="col-xl-6 col-md-6 couponR">
              <CouponGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" />
            </div>
            <div class="col-xl-6 col-md-6">
              <CallGraph v-bind:fromdate="fromDate" v-bind:todate="toDate" />
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div
        class="modal fade"
        id="printModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <p>Please select an option</p>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  value="Buy"
                  checked
                />
                <label class="form-check-label" for="inlineRadio1">Buy</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  value="Sell"
                />
                <label class="form-check-label" for="inlineRadio2">Sell</label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" @click="printReport()">Print PDF</button>
            </div>
          </div>
        </div>
      </div>
      <!-- <Footer /> -->
    </div>
  </div>
</template>

<script>
// import Header from "../common/Header";
// import Footer from "../common/Footer";
import MaturityGraph from "./MaturityGraph";
import InsuredGraph from "./InsuredGraph.vue";
import MoodysRatingGraph from "./MoodysRatingGraph.vue";
import SPRatingGraph from "./SPRatingGraph.vue";
import InsuranceGraph from "./InsuranceGraph.vue";
//import StatereportGraph from "./StatereportGraph.vue";
//import PurposeGraph from "./PurposeGraph.vue";
import CouponGraph from "./CouponGraph.vue";
import CallGraph from "./CallGraph.vue";
//import Tradecount from "./Tradecount.vue";
// import PurposeGraphwithGchart from "./PurposeGraphwithGchart.vue";
import StateReportGraphwithGchart from "./StateReportGraphwithGchart.vue";
//import $ from "jquery";

export default {
  name: "HomePage",
  components: {
    // Header,
    // Footer,
    MaturityGraph,
    InsuredGraph,
    MoodysRatingGraph,
    InsuranceGraph,
    //StatereportGraph,
    //PurposeGraph,
    CouponGraph,
    SPRatingGraph,
    CallGraph,
   // Tradecount,
    //PurposeGraphwithGchart,
    StateReportGraphwithGchart
  },
  data() {
    return {
      fromDate: "",
      toDate: ""
    };
  },
  methods: {
    setDate(){
      this.$root.$emit("tradedate",{fromDate:this.fromDate,toDate:this.toDate});
    },
    showPrintOptions() {
      window.$("#printModal").modal("show");

      // var maturitySell = document.getElementById("maturityCheck").checked;
      // var insured = document.getElementById("insuredCheck").checked;
      // var moody = document.getElementById("moodyCheck").checked;
      // var SP = document.getElementById("spCheck").checked;
      // var state = document.getElementById("stateCheck").checked;
      // var insurance = document.getElementById("insuranceCheck").checked;
      // var purpose = document.getElementById("purposeCheck").checked;
      // var coupon = document.getElementById("couponCheck").checked;
      // var call = document.getElementById("callCheck").checked;
      // let routeData = this.$router.resolve({
      //   name: "report",
      //   query: {
      //     fromDate: this.fromDate,
      //     toDate: this.toDate,
      //     maturity: maturitySell,
      //     insured: insured,
      //     moody: moody,
      //     SP: SP,
      //     state: state,
      //     insurance:insurance,
      //     purpose:purpose,
      //     coupon:coupon,
      //     call:call
      //   }
      // });
      // window.open(routeData.href, "_blank");
    },
    printReport() {
      // alert(window.$('input[name="inlineRadioOptions"]:checked').val())
      window.$("#printModal").modal("hide");
      let routeData = this.$router.resolve({
        name: "report",
        query: {
          fromDate: this.fromDate,
          toDate: this.toDate,
          isSell:
            window.$('input[name="inlineRadioOptions"]:checked').val() == "Sell"
              ? true
              : false
        }
      });
      window.open(routeData.href, "_blank");
    }
  },

  created() {
     this.toDate = new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "-");
    var ourDate = new Date();
    var pastDate = ourDate.getDate() - 7;
    ourDate.setDate(pastDate);
    this.fromDate = ourDate
      .toJSON()
      .slice(0, 10)
      .replace(/-/g, "-");
  },
  mounted() {
    this.$root.$on("onprint", () => {
      this.showPrintOptions();
    });
  }
};
</script>
<style scoped>
</style>